export default {
  data: function() {
    return {
      language: this.$store.getters.language,
      supportedLanguages: this.$store.getters.supportedLanguages
    }
  },
  methods: {
    toggleMenu: function (icon) {
      let $menu = $("#topMenu .ui.secondary.pointing.menu");
      $menu.toggleClass('open');

      $menu.find('#languageBar').toggleClass('menuOpen')
    }
  },
  computed: {
    menu: function() {
      let homeLabel = '/';
      let homeLink = '/';
      let aboutUsLabel = 'About us';
      let aboutUsLink = '/about-us';
      let servicesLabel = 'Services';
      let servicesLink = '/services';
      let adviceAndSupportLabel = 'Advice and support';
      let adviceAndSupportLink = '/advice-and-support';
      let contactLabel = 'Contact';
      let contactLink = '/contact';

      const languageValue = this.language.value;
      switch (languageValue) {
        case "nl": {
          aboutUsLabel = 'Over ons';
          aboutUsLink = '/over-ons';
          servicesLabel = 'Diensten';
          servicesLink = '/diensten';
          adviceAndSupportLabel = 'Advies en ondersteuning';
          adviceAndSupportLink = '/advies-en-ondersteuning';
        }
        default: {
          if (languageValue !== undefined) {
            homeLink = '/' + languageValue + homeLink;
            aboutUsLink = '/' + languageValue + aboutUsLink;
            servicesLink = '/' + languageValue + servicesLink;
            adviceAndSupportLink = '/' + languageValue + adviceAndSupportLink;
            contactLink = '/' + languageValue + contactLink;
          }
        }
      }

      return [
        {
          label: homeLabel,
          link: homeLink
        },
        {
          label: aboutUsLabel,
          link: aboutUsLink
        },
        {
          label: servicesLabel,
          link: servicesLink
        },
        {
          label: adviceAndSupportLabel,
          link: adviceAndSupportLink
        },
        {
          label: contactLabel,
          link: contactLink
        }
      ]
    },
    sadeButton: function() {
      let label = 'Request sampling and/or delivery';
      let link = 'https://sade.qsds.be';

      const languageValue = this.$store.getters.language.value;
      switch (languageValue) {
        case 'nl':
          label = 'Vraag staalname en/of transport aan'
          break;
      }

      return {
        label: label,
        link: link
      }
    }
  },
  mounted() {
    const vue = this;

    $("#languageBar")
      .dropdown()
      .find('input[type="hidden"]')
        .on("change", function() {
          const input = this;

          vue.supportedLanguages.forEach(function(lang) {
            if (lang.value === input.value) {
              vue.$store.commit('language', lang);
            } else {
              vue.$store.commit('language', {
                value : 'en',
                text : 'English'
              });
            }
          });
        });
  }
}



// WEBPACK FOOTER //
// ./src/pages/components/TopMenu/TopMenu.js